export const EOrderPaymentProviderType = {
  None: 0,

  MercadoPago: 1,
} as const

export type EOrderPaymentProviderType = (typeof EOrderPaymentProviderType)[keyof typeof EOrderPaymentProviderType]
